// extracted by mini-css-extract-plugin
export default {"errorAlert":"alert-error_errorAlert__JMf30"};